<template>
  <div id="reportsPage">

    <base-header class="pb-6 bg-light">
      <b-row aling-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Reports</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <span class="h3">Available Reports</span>
        </b-card-header>

        <b-card-body>

          <b-form>
            <b-row>

              <b-col xl="4" md="4" sm="12">
                <div class="mt-2">
                  <label for="reportName">Report:</label>
                  <b-form-select
                    id="reportName"
                    label="Report Name"
                    size="sm"
                    v-model="reportsForm.reportName"
                    :options="reportNameOption"
                    value-field="value"
                    text-field="value"
                    disabled-field="notEnabled"
                  ></b-form-select>
                </div>
              </b-col>

              <b-col xl="4" md="4">
                <div class="mt-2">
                  <label for="reportPeriod">Period:</label>
                  <b-form-select
                    id="reportPeriod"
                    size="sm"
                    v-model="reportsForm.reportPeriod"
                    :options="reportPeriodOption"
                    value-field="period"
                    text-field="period"
                    disabled-field="notEnabled"
                  ></b-form-select>
                </div>
              </b-col>

              <b-col xl="4" md="4" sm="12">
                <div class="mt-1 text-left">
                  <label class=" form-control-label font-weight-900 text-white">View Report</label><br>
                  <base-button type="primary" title="View Report" size="sm" class="mt-2" v-on:click="reportsSubmitSearch()" :loading="submitLoading">
                      View Report
                  </base-button>
                </div>
              </b-col>
            </b-row>
          </b-form>

          <hr>

          <transition name="slide-fade">
            <div v-if="isSearchTrue">
              <div class="text-center w-100">
                <b-icon icon="three-dots"
                        class="text-center" animation="cylon"
                        font-scale="4"
                        v-if="loadingStatus"></b-icon>
              </div>
              <div class="mb-3" v-if="!loadingStatus">
                <b-row>
                  <b-col xl="3" lg="3" md="3" sm="12">

                    <b-form-group
                      label=""
                      label-for="per-page-select"
                      label-cols-sm="0"
                      label-cols-md="0"
                      label-cols-lg="0"
                      label-align-sm="center"
                      label-size="sm"
                      class="mb-2 per-page-select"
                    >
                      <label for="per-page-select" class="mr-2 text-sm mt-1">Show</label>
                      <b-form-select
                        id="per-page-select"
                        class="diameter-report-select"
                        v-model="perPage"
                        :options="pageOptions"
                        v-on:input="changePageOption(perPage)"
                        size="sm"
                      ></b-form-select>
                      <label for="per-page-select" class="ml-2 text-sm mt-1">entries</label>
                    </b-form-group>

                  </b-col>
                  <b-col xl="6" lg="6" md="6" sm="12" class="">
                   <span v-b-modal.export-report v-on:click="reportsExportCsvFunc()" class="mt-1 cursor-pointer">
                       <i class="far fa-file-excel text-primary" style="font-size: 18px!important;"
                       ></i>
                    </span>
                  </b-col>
                  <b-col xl="3" lg="3" md="3" sm="12">
                    <b-form-group
                      label=""
                      label-for="filter-input"
                      label-align-sm="right"
                      label-size="sm"
                      class="mb-0"
                    >
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filter"
                          placeholder="Search..."
                          class="mb-4"
                        ></b-form-input>

                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="">
                  <b-col xl="12">
                    <p class="h4">Report : {{ reportsForm.reportName }}</p>
                    <p class="h4">Customer : {{ customerName }}</p>
                    <p class="h4">Period : {{ reportsForm.reportPeriod }}</p>
                  </b-col>

                </b-row>
                <div class="card-table-custom mb-3 text-center" v-if="paginationLoadingBar">

                  <p class="h4 pb-5 mb-5">
                    <b-table
                      :fields="tableColumns"
                    ></b-table>
                  </p>
                  <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
                  <b-row class="mt-5 pt-5">
                    <b-col>
                      <p class="ml-3 text-left">Showing {{ startPage }} to {{ fromPage }} of {{ totalRows }} entries</p>
                    </b-col>
                    <b-col xl="auto" md="auto" sm="auto ">
                      <b-pagination
                        class="flex-fill-custom pr-4 ml-3"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        v-on:input="reportsPaginationChanged(currentPage)"
                        size="sm"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="!paginationLoadingBar">
                  <b-table
                    striped hover
                    :items="tableData"
                    :fields="tableColumns"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    table-class="text-nowrap"
                    sticky-header="true"
                    class="data-management-table"
                    show-empty
                    responsive
                    small
                    @sort-changed="reportsSortColumnChanged"
                  >

                  </b-table>

                  <b-row class="mt-4">
                    <b-col>
                      <p class="ml-3">Showing {{ startPage }} to {{ fromPage }} of {{ totalRows }} entries</p>
                    </b-col>
                    <b-col xl="auto" md="auto" sm="auto ">
                      <b-pagination
                        class="flex-fill-custom pr-4 ml-3"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        v-on:input="reportsPaginationChanged(currentPage)"
                        size="sm"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </transition>
        </b-card-body>
      </b-card>
    </b-container>
    <b-modal centered size="lg" id="export-report" hide-footer title="Export Report" class="export-report"
             cancel-title="Close" ok-variant="primary" ok-title="Send">
      <ExportReport></ExportReport>
    </b-modal>
  </div>
</template>

<script>

  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import reportsDashboardService from "@/common/api-services/reports-dashboard-service";
  import ExportReport from "../../Components/Export-Report";
  import initService from "@/common/api-services/init-service";
  import configDirective from "../../../common/directive/config-directive";

  export default {
    name: "ReportsDashboard",
    components: {
      ExportReport,
      RouteBreadCrumb,
    },
    data() {
      return {
        reportsForm: {
          reportName: '',
          reportPeriod: '',
        },
        reportNameOption: [],
        reportPeriodOption: [],
        customerOption: [],
        defaultValue: 'Select One',
        loadingStatus: false,
        isSearchTrue: false,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        tableColumns: [],
        tableData: [],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        startPage: 1,
        fromPage: 10,
        lastPage: 1,
        loadingNum: 1,
        paginationLoadingBar: true,
        customerName: '',
        submitLoading: false
      }
    },
    mounted() {
      document.title = 'Reports';

      if (this.noAccess) {
        this.$router.push('/restricted')
      }


      this.customerName = initService.getCustomerInfo();
      this.reportsGetReportPeriodFunc();
      this.getTotalRows();
      this.loadReportList();
    },
    computed: {
      noAccess() {
          // Determine access based on menu link configuration
          let userRoles = initService.getUserRoles();
          let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

          if (!link) {
              return true;
          } else {
              userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
              return userRoles.length === 0;
          }
      }
    },
    methods: {

      getTotalRows() {
        if (this.perPage > this.totalRows) {
          this.fromPage = this.totalRows
        } else {
          this.fromPage = this.perPage
        }
      },

      loadReportList() {
        let data = configDirective.getReportsList();
        this.reportNameOption.push({value: 'Select One', text: 'Select One'})
        for (let key in data) {
          this.reportNameOption.push(key)
        }
      },

      reportsPaginationChanged(data) {
        //be aware that the API is using start=record to start on NOT page.
        if (data * 10 < this.totalRows) {
          this.fromPage = data * 10;
        } else {
          this.fromPage = this.totalRows
        }
        this.currentPage = data;
        this.startPage = (this.currentPage - 1) * this.perPage + 1;
        if (!this.tableData[this.startPage] || !this.tableData[this.startPage]['imsi']) {
          this.paginationLoadingBar = true;
          this.reportsSubmitSearch()
        }
      },

      reportsSortColumnChanged(e) {
        this.sortBy = e.sortBy;
        if (e.sortDesc === true) {
          this.sortDirection = 'asc';
        } else {
          this.sortDirection = 'desc'
        }
        this.reportsSubmitSearch();
      },

      reportsGetReportPeriodFunc() {
        reportsDashboardService.getReportPeriod().then(res => {
          let data = [{period: this.defaultValue}];
          res.map(item => {
            data.push(item)
          });
          this.reportPeriodOption = data;
          this.reportsForm.reportName = this.defaultValue;
          this.reportsForm.reportPeriod = this.defaultValue;
        })
      },

      reportsSubmitSearch() {
        this.loadingStatus = true;
        let {reportName, reportPeriod, customer} = this.reportsForm;
        if (reportName === this.defaultValue) {
          this.$toast.error('Error - Please select a valid report.')
          return false;
        }
        if (reportPeriod === this.defaultValue) {
          this.$toast.error('Error - Please select a valid reporting period.')
          return false;
        }
        if (reportName !== this.defaultValue && reportPeriod !== this.defaultValue) {
          this.submitLoading = true;
          //set the sort
          if (this.sortBy === '') this.sortBy = 'date';
          if (this.sortDirection === '') this.sortDirection = 'asc';
          let reportSort = '%60' + this.sortBy + '%60%20' + this.sortDirection;
          this.reportsSelectedColumn(reportName);  //what does this do??
          this.isSearchTrue = true;
          reportsDashboardService.getViewReport(reportName, reportPeriod, reportSort, Math.floor(this.startPage / 100) * 100).then(res => {
            this.submitLoading = false;
            if (res) {
              this.loadingStatus = false;
              this.paginationLoadingBar = false;
              this.lastPage = Math.floor(this.totalRows / 10) + 1;
              this.tableData = Array(Math.floor(this.startPage / 100) * 100).fill({});
              if (res.result) {
                res.result.map(item => {
                  this.tableData.push(item);
                });
              } else {
                this.tableData = []
              }
              this.totalRows = res.total;
              this.getTotalRows();
            }
          });
        }
      },

      reportsSelectedColumn(reportName) {
        this.tableColumns = [];
        let columnList = configDirective.getReportColumns(reportName);
        Object.keys(columnList).find((item) => {
          let child = {key: item, label: item, sortable: true, sortDirection: 'desc'};
          this.tableColumns.push(child)
        })
      },

      reportsExportCsvFunc() {
        let data = [];
        data.reportName = this.reportsForm.reportName;
        data.reportPeriod = this.reportsForm.reportPeriod;
        setTimeout(() => {
          this.$root.$emit('exportReportData', data);
        }, 1000)
      },

      changePageOption(page) {
        this.fromPage = page
      },
    },
    watch: {}
  }

</script>
